import React, { useEffect, useState } from 'react'
import { AppDropdown } from './AppDropdown'
import { IWithPaginationRequestSearch } from '../../core/api/dto/BaseDto'
import { emptyResponse } from '../../utils/emptyResponse'
import { LIMIT } from 'utils/constants'

export interface IExtraOptions {
  [key: string]: string | number | boolean | undefined | (string | number)[]
}

interface IAppDropdownWithPaginationProps<T, TKey> {
  value: T | null
  propToShowInList?: TKey // если data массив строк, то не передаем propToShowInList и propToShowInInput
  sparePropToShowInList?: TKey
  extraPropToShowInList?: TKey
  propToShowInInput?: TKey
  onChange: (value: T) => void
  resetValueHandler?: () => void
  getterData: (params: any, extraParams?: any) => any
  label?: string
  require?: boolean
  placeholder?: string
  id?: string
  emptyListMessage?: string
  error?: string | null
  disabled?: boolean
  fullWidth?: boolean
  border?: boolean
  multiValue?: T[] | []
  extraOptions?: IExtraOptions
  skip?: boolean
  required?: boolean
  minWidth?: boolean
  tag?: boolean
  labelList?: string
  onDeleteFromList?: (value: number | string) => void
  showArchivedItems?: boolean //контролирует показ архивированных позиций, по умолчанию false
  limit?: number
}

const AppDropdownWithPagination = <T, TKey extends keyof T>({
  emptyListMessage,
  extraOptions,
  getterData,
  multiValue,
  resetValueHandler,
  value,
  onChange,
  fullWidth,
  label,
  placeholder,
  skip,
  error,
  propToShowInList,
  propToShowInInput,
  extraPropToShowInList,
  sparePropToShowInList,
  disabled,
  border,
  required,
  minWidth,
  id,
  tag,
  labelList,
  onDeleteFromList,
  showArchivedItems,
  limit = LIMIT,
}: IAppDropdownWithPaginationProps<T, TKey>) => {
  const [params, setParams] = useState<IWithPaginationRequestSearch | null>({
    limit: limit,
    ...(showArchivedItems ? {} : { is_archived: false }),
  })
  const [inputValue, setInputValue] = useState<string>('')

  const [resetData, setResetData] = useState<boolean>(false)

  const { data, isFetching } = getterData(
    !!params
      ? {
          ...extraOptions,
          ...params,
        }
      : !!extraOptions
      ? extraOptions
      : null,
    { skip: !!skip || !params },
  )

  useEffect(() => {
    if (!!extraOptions) {
      setInputValue('')
      setParams((prevState) => ({
        ...prevState,
        limit: limit,
        offset: 0,
      }))
      if (!!data && !!data.results) {
        setResetData(true)
      }
    }
  }, [JSON.stringify(extraOptions)])

  useEffect(() => {
    const handler = setTimeout(() => {
      if (inputValue === '') {
        setParams({
          limit: limit,
          ...(showArchivedItems ? {} : { is_archived: false }),
        })
      } else {
        setParams({
          limit: limit,
          search: inputValue,
          ...(showArchivedItems ? {} : { is_archived: false }),
        })
      }
    }, 500)

    return () => {
      clearTimeout(handler)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputValue])

  const inputSearchFn = (value: string) => {
    setInputValue(value)
  }
  const onChangeHandler = (value: T) => {
    onChange(value)
  }

  return (
    <AppDropdown
      label={label}
      loadMoreCallBack={(newPageParams) => {
        setParams((prev) => {
          return { ...prev, ...newPageParams }
        })
      }}
      resetData={resetData}
      setResetData={setResetData}
      placeholder={
        !!emptyListMessage && !!data && !data.results.length && !inputValue
          ? emptyListMessage
          : placeholder
      }
      propToShowInList={propToShowInList}
      error={error}
      data={!!data ? data : (emptyResponse as any)}
      value={value}
      onChange={onChangeHandler}
      inputSearch={inputValue}
      inputSearchFn={inputSearchFn}
      propToShowInInput={propToShowInInput}
      disabled={disabled}
      resetValueHandler={resetValueHandler}
      multiValue={multiValue}
      fullWidth={fullWidth}
      onDeleteFromList={onDeleteFromList}
      border={border}
      isFetching={isFetching}
      required={required}
      minWidth={minWidth}
      extraPropToShowInList={extraPropToShowInList}
      sparePropToShowInList={sparePropToShowInList}
      id={`-pag-dr${id || ''}`}
      tag={tag}
      withList={true}
    />
  )
}

export default AppDropdownWithPagination
